import { render, staticRenderFns } from "./pagemiddle.vue?vue&type=template&id=20e6a6ea&scoped=true&"
import script from "./pagemiddle.vue?vue&type=script&lang=js&"
export * from "./pagemiddle.vue?vue&type=script&lang=js&"
import style0 from "./pagemiddle.vue?vue&type=style&index=0&id=20e6a6ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e6a6ea",
  null
  
)

export default component.exports